import { render, staticRenderFns } from "./BtnNovoPedido.vue?vue&type=template&id=73c0e883&"
import script from "./BtnNovoPedido.vue?vue&type=script&lang=js&"
export * from "./BtnNovoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports